module.exports = "/packs/media/images/brands/morganstanley-4fd14ce575b4065e01aab794620f5ba9.png";